var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center mw8 pa3-ns pa2",attrs:{"id":"app"}},[_c('router-view'),_c('v-tour',{attrs:{"name":"tour","steps":_vm.steps,"callbacks":_vm.callbacks,"options":{ highlight: true }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }